var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0128 4.025H18.2874C18.383 4.025 18.4681 4.08537 18.4997 4.17556L19.1293 5.97125H13.0128V4.025ZM10.9878 4.025H5.71163C5.61606 4.025 5.53092 4.08537 5.4993 4.17556L4.86975 5.97125H10.9878V4.025ZM10.9878 7.99625H4.15981H2.01397L2.72391 5.97125L3.58834 3.5056C3.90453 2.60373 4.75594 2 5.71163 2H18.2874C19.2431 2 20.0945 2.60373 20.4107 3.5056L21.2751 5.97125L21.9851 7.99625H19.8392H13.0128V7.99628H10.9878V7.99625ZM4.02598 18.7382V7.99634H2.00098V18.7382C2.00098 20.54 3.46165 22.0007 5.26348 22.0007H18.7375C20.5393 22.0007 22 20.54 22 18.7382V7.99634H19.975V18.7382C19.975 19.4217 19.4209 19.9757 18.7375 19.9757H5.26348C4.58002 19.9757 4.02598 19.4217 4.02598 18.7382ZM9.75309 13.0062H11.9998H14.2466V10.9812H11.9998H9.75309V13.0062Z",
    fill: "url(#paint0_linear_8309_14519)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8309_14519",
    x1: -9.49845,
    y1: 1.5815,
    x2: -9.49845,
    y2: 18.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectPickup);
export default __webpack_public_path__ + "static/media/direct-pickup.e5946684.svg";
export { ForwardRef as ReactComponent };